// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsColumn_root__E8brq"};